"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectTypeOptions = exports.ProjectTypeGroup = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const featureFlags_1 = require("../../../common/featureFlags");
const localizeUtils_1 = require("../../../common/localizeUtils");
var ProjectTypeGroup;
(function (ProjectTypeGroup) {
    ProjectTypeGroup["AIAgent"] = "AI Agent";
    ProjectTypeGroup["M365Apps"] = "Apps for Microsoft 365";
})(ProjectTypeGroup || (exports.ProjectTypeGroup = ProjectTypeGroup = {}));
class ProjectTypeOptions {
    static copilotAgentOptionId = "copilot-agent-type";
    static customEngineAgentOptionId = "custom-engine-agent-type";
    static teamsOptionId = "teams-agent-and-app-type";
    static outlookAddinOptionId = "outlook-addin-type";
    static officeMetaOSOptionId = "office-meta-os-type";
    static graphConnectorOptionId = "graph-connector-type";
    static startWithGithubCopilotOptionId = "start-with-github-copilot";
    static groupName(group) {
        switch (group) {
            case ProjectTypeGroup.AIAgent:
                return (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.createGroup.aiAgent");
            case ProjectTypeGroup.M365Apps:
                return (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.createGroup.m365Apps");
        }
    }
    static teamsAgentsAndApps(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.teamsOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(microsoft365-agents-toolkit-teams) " : ""}${(0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.teamsAgentsAndApps.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.teamsAgentsAndApps.detail"),
            groupName: ProjectTypeOptions.groupName(ProjectTypeGroup.M365Apps),
        };
    }
    static officeMetaOS(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.officeMetaOSOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(microsoft365-agents-office) " : ""}${(0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.officeAddin.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.officeAddin.detail"),
            groupName: ProjectTypeOptions.groupName(ProjectTypeGroup.M365Apps),
        };
    }
    static officeAddin(platform = teamsfx_api_1.Platform.VSCode) {
        return this.officeMetaOS(platform);
    }
    static declarativeAgent(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.copilotAgentOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(teamsfx-agent) " : ""}${(0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.declarativeAgent.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.declarativeAgent.detail"),
            groupName: ProjectTypeOptions.groupName(ProjectTypeGroup.AIAgent),
        };
    }
    static customEngineAgent(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.customEngineAgentOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(teamsfx-custom-copilot) " : ""}${(0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.customCopilot.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.customCopilot.detail"),
            groupName: ProjectTypeOptions.groupName(ProjectTypeGroup.AIAgent),
        };
    }
    static graphConnector(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.graphConnectorOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(teamsfx-graph-connector) " : ""}${(0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.createGraphConnector.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.createGraphConnector.detail"),
            groupName: ProjectTypeOptions.groupName(ProjectTypeGroup.AIAgent),
        };
    }
    static startWithGithubCopilot() {
        const description = featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.HideGitHubCopilotPreviewTag)
            ? undefined
            : (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.preview");
        return {
            id: ProjectTypeOptions.startWithGithubCopilotOptionId,
            label: `$(question) ${(0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.copilotHelp.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.copilotHelp.detail"),
            groupName: (0, localizeUtils_1.getLocalizedString)("template.createProjectQuestion.projectType.copilotGroup.title"),
            description,
        };
    }
}
exports.ProjectTypeOptions = ProjectTypeOptions;
//# sourceMappingURL=ProjectTypeOptions.js.map